import { useMutation, useQuery } from '@apollo/client';
import { GetMyNoteInClasseQuery } from '../graphql/generated/graphql';
import { MY_ID } from '../helpers/user/authorization';
import { UPDATE_MY_NOTE } from '../graphql/mutation/note/updateNoteEleve';
import { useEffect } from 'react';
import { shouldUpdateNote } from '../helpers/note/updateNote';
import toast from 'react-hot-toast';
import { QUERY_GET_MY_NOTE_IN_CLASSE } from '../graphql/query/note/getNoteQuery';

export const useShouldUpdateNote = () => {
  const { data } = useQuery<GetMyNoteInClasseQuery>(
    QUERY_GET_MY_NOTE_IN_CLASSE,
    {
      variables: {
        id: MY_ID
      }
    }
  );

  const [updateMyNote] = useMutation(UPDATE_MY_NOTE, {
    onCompleted: () => {
      toast.success('Mise à jour effectuée avec succès');
    },
    onError: e => {
      toast.error(e.message);
    }
  });

  useEffect(() => {
    data &&
      shouldUpdateNote(data?.getMyNoteInClasse.note.attributes.updatedAt) &&
      updateMyNote();
  }, [data, updateMyNote]);
};
